export const API_ENDPOINT = 'http://localhost:8000';
export const GOOGLE_CLIENT_ID = "1020175780794-o8perjgbl8n5kdn99vlblo8gse8nbuvi.apps.googleusercontent.com";